<template>
  <div class="authentication">
    <div class="authentication__title">
      <h1>Планета Вита</h1>
    </div>
    <authenticationDialog />
    <div class="authentication__end"></div>
  </div>
</template>

<script setup lang="ts">
import authenticationDialog from '@/components/AuthenticationDialog.vue'
</script>

<style lang="scss" scoped>
@use '../static/style/variables.scss' as *;

.authentication {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background-color: $blue;
  background-image: url(../static/img/background.png);
  background-position: 50% 50%;
  background-size: cover;

  &__title {
    height: 100%;
    display: flex;
    h1 {
      font-size: 40px;
      font-weight: 700;
      line-height: 49px;
      color: $white;
      margin: auto;
    }
  }

  &__end {
    height: 100%;
  }
}
</style>